import React from 'react';

type ChangePendingLoads = (delta: number) => void;

/** Provided by SettingsPageColumn only, so the hook does nothing outside the `new-settings` layout. */
export const SettingsPageLoadingContext =
  React.createContext<ChangePendingLoads>(() => undefined);

/**
 * Swaps the whole settings page for one centered loader while `isLoading`, so
 * the title and cards appear together instead of piece by piece. A count
 * rather than a flag, so a plan gate and the list inside it can each hold the
 * page without one clearing the other.
 */
export const useSettingsPageLoading = (isLoading: boolean) => {
  const changePendingLoads = React.useContext(SettingsPageLoadingContext);

  // A layout effect so the loader is in place before the page first paints.
  React.useLayoutEffect(() => {
    if (!isLoading) return undefined;
    changePendingLoads(1);
    return () => changePendingLoads(-1);
  }, [isLoading, changePendingLoads]);
};
